import { Constraints, Platform, TimeRange } from '@fullstory/proto/fs/api/segment';
import { Duration } from '@fullstory/proto/google/protobuf';
import { DEFAULT_MEASURE } from '@fullstory/metrics-model';

export const DEFAULT_TIME_RANGE: TimeRange = {
  startTime: 'NOW/DAY-6DAY',
  endTime: 'NOW/DAY+1DAY',
};

export const DEFAULT_CONSTRAINTS: Constraints = {
  platform: Platform.PLATFORM_WEB,
  timeRange: DEFAULT_TIME_RANGE,
  inOrder: false,
  inSameSession: false,
  completeSessions: false,
  withinTime: Duration.zero,
  eventThresholds: [],
};

export { DEFAULT_MEASURE };
export const SORT_QUERY_PARAM = 'sort';
